import React, { useEffect, useRef, useState } from "react";
import MegaJackpotImage from "../assets/images/mega-jackpot-card-image.svg";
import MegaJackpotImage1 from "../assets/images/mega-jackpot-image.svg";
import { useTranslation } from "react-i18next";
import Countdown from "react-countdown";
import Completionist from "../components/Completionist";
import { useNavigate } from "react-router";
import {
    getUserInfo,
    addressToHisReferrer,
    addUserToMlm,
    getMegaJackpotStartTime,
    startMegaJackpot,
    getMegaTicketsCount,
    timeForMega,
    megaJackpotAmount,
    monthlyJackpotStartTimestamp,
    calculateMega,
    isMegaActive,
} from "../web3";
import { Carousel, Spin } from "antd";
import CarouselItem from "../components/CarouselItem";

import BuyTicketIcon from "../assets/icons/buy-ticket-icon.svg";



function AuthLayouth({ address, chainId, isConnected, status, open, provider }: any) {
    const [timeStamp, setTimeStamp] = useState<any>();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [isFlipped, setFlipped] = useState(false);
    const [activeIndex, setActiveIndex] = useState<any>(0);
    const [loading, setLoading] = useState<any>(true);
    const [timestampCompleted, setTimestampCompleted] = useState<any>(false);
    const [timeForMegaJackpot, setTimeForMegaJackpot] = useState<any>();
    const [amountForMegaJackpot, setAmountForMegaJackpot] = useState<any>();
    const [megaTicketsCount, setMegaTickcetsCount] = useState<any>();
    // const [language, setLanguage] = useState<any>("");
    const carouselRef = useRef<any>(null);
    const [value, setValue] = useState(localStorage.getItem('lang'));
    const [flipCardsData, setFlipCardsData] = useState<any>([]);
    const [isMegaJackpotActive, setIsMegaJackpotActive] = useState<any>();


    const flipCardsDataFromBackend = (fetchedImages: any) => {
        return [
            {
                bgFront: fetchedImages[0]?.url || "",
                bgBack: fetchedImages[1]?.url || "",
                textFront1: "Зарабатывай",
                textFront2: "на выигрышах",
                textFront3: "друзей!",
                textBack:
                    "Твой шанс заработать без вложений!777 билетов - 203 гарантированных выигрыша и шанс сорвать главный приз Джекпот!",
            },
            {
                bgFront: fetchedImages[2]?.url || "",
                bgBack: fetchedImages[3]?.url || "",
                textFront1: "Твой шанс",
                textFront2: "заработать",
                textFront3: "без вложений!",
                textBack:
                    "5 USDT – за 10 купленных билетов.100 USDT – за 50 проданных билетов.5 USDT – за 10 рефералов.50 USDT – за 3 победы подряд.",
            },
            {
                bgFront: fetchedImages[4]?.url || "",
                bgBack: fetchedImages[5]?.url || "", // можно повторно использовать
                textFront1: "777 билетов",
                textFront2: "203 гарантированных",
                textFront3: "выигрыша",
                textBack:
                    "Твой шанс заработать без вложений! Привлекай игроков – получай реальные доход! 5% от стоимости билета – за каждого нового игрока,если привлек до 5 игроков. 10% от суммы покупки – если привлек 5 и более игроков.",
            },
            {
                bgFront: fetchedImages[6]?.url || "",
                bgBack: fetchedImages[7]?.url || "",
                textFront1: "БОЛЬШЕ",
                textFront2: "АКТИВНОСТИ",
                textFront3: "БОЛЬШЕ ДЕНЕГ",
                textBack:
                    "Многоуровневая реферальная система – Зарабатывай на выигрышах друзей! 1 уровень – 10% от выигрыша каждого игрока, которого пригласил лично! 2 уровень – 5% от выигрыша каждого игрока, которого пригласил твой реферал! 3 уровень – 2% от выигрыша игрока, пришедших через сеть второго уровня!",
            },
        ];
    };


    useEffect(() => {
        const fetchImages = async () => {
            try {
                const res = await fetch("https://cryptolottery777.com/public/image"); // твой API endpoint
                const data: any = await res.json();

                setFlipCardsData(flipCardsDataFromBackend(data));
            } catch (err) {
                console.error("Ошибка при загрузке изображений:", err);
            }
        };

        fetchImages();
    }, []);


    useEffect(() => {
        console.log("Amount", amountForMegaJackpot);

        megaJackpotAmount().then((res) => {
            console.log("Amount", res);
            setAmountForMegaJackpot(res)
        })

        timeForMega().then((res: any) => {
            console.log("test", res);

            setTimeForMegaJackpot(res)

        })
        const interval = setInterval(() => {
            const newValue = localStorage.getItem('lang');
            if (newValue !== value) {
                setValue(newValue);
            }
        }, 500); // проверка каждые полсекунды

        return () => clearInterval(interval);
    }, [value]);


    useEffect(() => {
        setTimeout(() => {
            setLoading(false)
        }, 200)
    }, [])

    useEffect(() => {
        isMegaActive().then((res: any) => {
            console.log("isMegaActive", res);
            setIsMegaJackpotActive(res)
        })

        monthlyJackpotStartTimestamp().then((res: any) => {
            console.log("res", res);

            const startTime = res * 1000; // Ensure it's a number

            const thirtyDaysLater = startTime + Number(timeForMegaJackpot) * 1000; // Add 30 days
            console.log("Timer", startTime);

            setTimeStamp(thirtyDaysLater);
            console.log("time", timeForMegaJackpot);

        });
    }, [timeForMegaJackpot]);


    const handleBuyMegaJackpotTicket = () => {
        navigate("./mega-jackpot")
    }

    const renderer = ({ days, hours, minutes, seconds, completed }: any) => {

        setTimestampCompleted(completed)
        if (completed && isMegaJackpotActive) {
            getMegaTicketsCount().then(count => {
                if (count === 0) {
                    calculateMega().then((res) => {
                        console.log("Calculate Mega Response", res);
                    })
                }
            });
        }

        if (completed && isMegaJackpotActive) {
            // Render a complete state
            return (
                <div className="flip-button-front mt-12" onClick={handleBuyMegaJackpotTicket}>
                    <img src={BuyTicketIcon} alt="" className="flip-button-icon" />
                    <span className="mega-jackpot-buy-button-text">{t('Купить билет')}</span>
                </div>
            )
        } else {

            // Render a countdown
            return (
                <>

                    <Completionist style={{ width: "100%" }}
                        days={days}
                        hours={hours}
                        minutes={minutes}
                        seconds={seconds}
                        isMini
                    />
                    <p className="mega_info_block">
                        {t('Количество проданных Билетов в Мега Джекпот не хватает для розыгрыша!!!')}
                    </p>
                </>
            );

        }
    };


    const handleBuyJackpotTicket = async () => {
        if (isConnected) {
            navigate('/jackpot');
        } else {
            open();
        }
    };
    const goToSlide = (slideNumber: number, dontAnimate = false) => {

        carouselRef.current?.goTo(slideNumber, dontAnimate);
    };

    const handleFlip = () => {
        setFlipped(!isFlipped);
    };

    const handleChangeBefore = () => {
        setFlipped(false);
    }
    const handleChangeAfter = (e: any) => {
        setActiveIndex(e)
    }




    return (
        <>
            {loading ? <Spin fullscreen={true} size="large" /> :
                <div className="auth-layout">
                    <div className="carousel">
                        <Carousel
                            beforeChange={handleChangeBefore}
                            afterChange={handleChangeAfter}
                            ref={carouselRef}
                            dots={false}
                        >
                            {flipCardsData.map((card: any, index: any) => {
                                return (
                                    <CarouselItem
                                        key={index}
                                        isFlipped={isFlipped}
                                        func={handleFlip}
                                        handleBuyJackpotTicket={handleBuyJackpotTicket}
                                        card={card}
                                    />
                                )
                            })}
                            {["RU", "EN", "ES", "PT", "TR"].includes(value || "") && (
                                <div key={value}>
                                    <video
                                        key={value}
                                        controls
                                        style={{ height: "212px", borderRadius: "16px" }}
                                        playsInline
                                    >
                                        <source
                                            src={
                                                value === "RU"
                                                    ? "https://cryptolottery777.com/public/video/2"
                                                    : value === "EN" ? `https://cryptolottery777.com/public/video/2/en`
                                                        : value === "ES" ? `https://cryptolottery777.com/public/video/2/es`
                                                            : value === "PT" ? `https://cryptolottery777.com/public/video/2/pt`
                                                                : value === "TR" ? `https://cryptolottery777.com/public/video/2/tr`
                                                                    : ""
                                            }
                                            type="video/mp4"
                                        />
                                        {t("Ваш браузер не поддерживает HTML-видео.")}
                                    </video>
                                </div>
                            )}

                        </Carousel>
                        <div className="dots-group">
                            {Array.from({ length: 5 }).map(((el, index) => {
                                return (
                                    <div
                                        key={index}
                                        onClick={() => goToSlide(index)}
                                        className={activeIndex === index ? "dot-active" : "dot"}
                                    >
                                    </div>
                                )
                            }))}
                        </div>
                    </div>
                    <div className="mega-jackpot-card">
                        <div className="mega-jackpot-card_top">
                            <div className="mega-jackpot-card_header">
                                <div className="mega-jackpot-card_header__title">
                                    {t('Мега Джекпот')}
                                </div>
                                <div className="mega-jackpot-card_header__content">
                                    {t('У вас есть шанс стать обладателем огромного приза, который изменит вашу жизнь навсегда. Время идет!')}
                                </div>
                                {timeStamp && (
                                    <div className="mini-datetime-container">
                                        <Countdown
                                            date={timeStamp}
                                            renderer={renderer}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="block">
                            <div className="block_left">
                                {t("СУММА РОЗЫГРЫША")}
                            </div>
                            <div className="block_right">
                                {Number(amountForMegaJackpot % 1 === 0
                                    ? Number(amountForMegaJackpot).toFixed(0)
                                    : Number(amountForMegaJackpot).toFixed(1))} $
                            </div>

                        </div>
                        <img src={MegaJackpotImage1} alt="image" className="mega-jackpot-card-image" />
                    </div>
                </div>
            }
        </>
    )
}

export default AuthLayouth;
